import React from 'react';
import { Grid2 } from '@mui/material';
import SearchInput from '../../../shared/components/student/SearchInput';
import { FilterButton } from '../../../shared/utils/IconButton';

const AdminToolbar = ({ onSearchChange, placeholder, onFilterClick, filterIcon, filterProps = {} }) => (
    <Grid2 container spacing="20px" width={{ xs: "90%", sm: "60%" }} justifyContent="flex-end">
    {onSearchChange &&  <SearchInput onChange={onSearchChange} placeholder={placeholder} />}   
        {onFilterClick && (
            <FilterButton
                bgcolor={"transparent"}
                border={"0.5px solid #A9B7FD"}
                src={filterIcon}
                onClick={onFilterClick}
                {...filterProps}
            />
        )}
    </Grid2>
);

export default AdminToolbar; 